module.exports = __webpack_public_path__ + "img/logo-topfun.1556c3d8.svg";